<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 512 512"
    preserveAspectRatio="xMidYMid meet"
  >
    <g transform="translate(0, 512) scale(0.100000, -0.100000)" :fill="color" stroke="none">
      <path
        d="M1825 3753 c-403 -52 -748 -290 -927 -640 -58 -112 -92 -206 -113 -316 l-18 -87 -303 0 -304 0 0 -150 0 -150 304 0 303 0 18 -87 c80 -404 370 -741 765 -890 123 -47 224 -64 410 -70 166 -5 178 -4 218 16 71 36 82 70 82 266 l0 165 225 0 225 0 0 150 0 150 -225 0 -225 0 0 450 0 450 225 0 225 0 0 150 0 150 -225 0 -225 0 0 165 c0 146 -2 170 -20 205 -35 68 -73 80 -242 79 -79 -1 -156 -4 -173 -6z"
      />
      <path
        d="M3988 3739 c-67 -35 -78 -72 -78 -264 l0 -165 150 0 150 0 0 -150 0 -150 -150 0 -150 0 0 -450 0 -450 150 0 150 0 0 -150 0 -150 -150 0 -150 0 0 -165 c0 -194 11 -230 80 -265 38 -19 58 -20 505 -20 l465 0 0 1200 0 1200 -467 0 c-446 -1 -470 -2 -505 -21z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
